<template>
    <div>
        <h2 class="text-center">
            404 Not Found
        </h2>
    </div>
</template>

<script>
    export default {
        name: 'not-found'
    }
</script>

<style lang="scss" scoped>

</style>